import { createSlice } from '@reduxjs/toolkit'

export const companyConfigEmpty = {}

export const createCompanyConfigSlice = createSlice({
  name: 'create_config_company',
  initialState: companyConfigEmpty,
  reducers: {
    createCompanyConfig: (_, action) => action.payload,
    modifyCompanyConfig: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    resetCompanyConfig: () => companyConfigEmpty,
  },
})
export const { createCompanyConfig, modifyCompanyConfig, resetCompanyConfig } =
  createCompanyConfigSlice.actions
export default createCompanyConfigSlice.reducer
